import React from "react";
import { motion } from "framer-motion";
// import { IoCheckmark } from "react-icons/io";
import "../styles/GasMonitization.css";

import { IoCheckmark } from "react-icons/io5";

const fadeLeft = {
  hidden: { opacity: 0, x: -40 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.7 } },
};
const fadeRight = {
  hidden: { opacity: 0, x: 40 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.7 } },
};
const fadeUp = {
  hidden: { opacity: 0, filter: "blur(8px)" },
  visible: { opacity: 1, filter: "blur(0)", transition: { duration: 1 } },
};

const GasMonitization = () => (
  <div className="gasmon-container">
    {/* Hero Section */}
    <motion.div
      className="gasmon-hero"
      initial="hidden"
      animate="visible"
      variants={fadeUp}
    >
      <img
        src="../../Images/Gas-pipelines.jpg"
        alt="Offshore Gas Production Platform"
      />
      <div className="gasmon-hero-overlay">
        <div>
          <h1>Gas Monetization</h1>
          <h2 className="gasmon-subtitle">
            Transforming Stranded Resources Into Economic Value
          </h2>
        </div>
      </div>
    </motion.div>

    {/* Market Dynamics Section */}
    <div className="container">
      <section className="gasmon-feature-section">
        <div className="gasmon-feature-grid">
          <motion.div
            className="gasmon-text"
            variants={fadeLeft}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.4 }}
          >
            <h2>Market Dynamics and Regional Opportunities</h2>
            <p>
              Natural gas monetization is Africa’s most dynamic energy
              subsector. Its investment share is projected to reach{" "}
              <strong>40% of total hydrocarbon CAPEX</strong> by 2030.
            </p>
            <p>In 2025 alone:</p>
            <ul className="gasmon-bullet-list">
              <p>
                <IoCheckmark className="check-icon" />
                Natural gas consumption to rise by 4% (driven by industrialization and power sector demand), creating substantial opportunities for innovative gas monetization solutions
              </p>
            </ul>
            Nigeria's <strong>"Decade of Gas"</strong> initiative and <strong>NLNG's Train-7</strong> expansion will create substantial feedgas demand, with the $4.3 billion project reaching 67% completion and employing over <strong>9,000 Nigerians</strong>
          </motion.div>
          <motion.div
            className="gasmon-image"
            variants={fadeRight}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.4 }}
          >
            <img
              src="../../Images/gas-prod.jpg"
              alt="Offshore Gas Production Platform"
            />
          </motion.div>
        </div>
      </section>

      {/* GGGP Section */}
      <motion.section
        className="gasmon-feature-section gasmon-alt-bg"
        variants={fadeLeft}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.4 }}
      >
        <h2>Gulf of Guinea Gas Project (GGGP) Development</h2>
        <p  >
          The <strong>Gulf of Guinea Gas Project (GGGP)</strong> represents GGOEX's flagship initiative to demonstrate technical excellence in Nigeria's gas sector. Currently in conceptual development, GGGP targets <strong>200 MMscfd gas processing capacity</strong> through Mobile Offshore Production Unit (MOPU) conversion technology, addressing Nigeria's feedgas supply needs while aligning with the country's environmental objectives. The zero-flare design aims for <strong>98% gas utilization efficiency</strong>, supporting Nigeria's commitment to eliminate routine gas flaring by 2030 and achieve net-zero carbon emissions by 2060.
        </p>
        <p  >
          Strategically located in Nigeria's matured oil assets, GGGP leverages proximity to existing infrastructure, including potential integration with established pipeline networks. The development timeline targets <strong>final investment decision in Q3 2025</strong>, with <strong>first gas delivery in Q2 2026</strong>, supporting Nigeria's gas supply objectives during a period when the country is experiencing renewed offshore project development. Emphasizing local content compliance, the project targets <strong>35% procurement through Nigerian fabrication facilities</strong>, demonstrating commitment to national economic development in accordance with the Nigerian Oil and Gas Industry Content Development Act requirements.
        </p>
        <br />
        <h3>Converting Stranded Resources into Economic Value Through Innovation</h3>
        <p  >
          GGGP advances through FEED stage with zero-flare gas processing via MOPU conversion technology, addressing Nigeria's natural gas commercialization challenges. The project targets <strong>98% gas utilization efficiency</strong> using advanced processing systems including triethylene glycol dehydration and carbon capture technologies. Its strategic location enables integration with existing pipeline infrastructure, leveraging Nigeria's position as the world's seventh most gas-endowed nation with approximately <strong>180 trillion cubic feet of natural gas deposits</strong>.
        </p>
        <ul className="gasmon-bullet-list">
          <li><IoCheckmark className="check-icon" /><p>MOPU conversion retrofits jack-up rigs with ABS-certified modules for <strong>200 MMscfd gas</strong> and <strong>30,000 bbl/d condensate</strong> production</p></li>
          <li><IoCheckmark className="check-icon" /><p>Flexible deployment without specialized offshore installation vessels—ideal for Nigeria's shallow water fields</p></li>
          <li><IoCheckmark className="check-icon" /><p>Reduced schedules, lower costs versus conventional developments, and minimized financial risks due to mobility and reusability</p></li>
          <li><IoCheckmark className="check-icon" /><p>GHGSat satellite-based methane monitoring, generating <strong>500,000 tCO₂e yearly</strong> in carbon credits while supporting environmental monitoring capabilities</p></li>
          <li><IoCheckmark className="check-icon" /><p>Aligns with Nigeria's CO₂ Storage Atlas identifying <strong>10,700 gigatonnes</strong> of prospective storage resources</p></li>
        </ul>
        <p  >
          This positions GGOEX at the forefront of sustainable gas processing and CCUS integration.
        </p>
      </motion.section>

      {/* Table Section */}
      {/* <section className="gasmon-overview">
        <motion.h2
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.4 }}
        >
          GGGP Technical Overview
        </motion.h2>
        <motion.div
          className="gasmon-table-wrapper"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.4 }}
        >
          <table className="gasmon-table">
            <tbody>
              <tr>
                <th>Component</th>
                <th>Description</th>
              </tr>
              <tr>
                <td>Target Capacity</td>
                <td>200 MMscfd gas, 30,000 bbl/d condensate</td>
              </tr>
              <tr>
                <td>Flare Rate</td>
                <td>0% (Zero-Flare)</td>
              </tr>
              <tr>
                <td>Monitoring</td>
                <td>GHGSat satellite methane tracking</td>
              </tr>
              <tr>
                <td>Gas Utilization Efficiency</td>
                <td>98%</td>
              </tr>
              <tr>
                <td>Location</td>
                <td>Nigeria shallow offshore</td>
              </tr>
              <tr>
                <td>Methane Credit Potential</td>
                <td>500,000 tCO₂e/year</td>
              </tr>
            </tbody>
          </table>
        </motion.div>
      </section> */}

      {/* Commercial Framework Section */}
      <section className="gasmon-feature-section">
        <motion.div
          className="gasmon-text"
          variants={fadeLeft}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.4 }}
        >
          <h2>Commercial Framework &amp; Integration</h2>
          <p >
            GGGP's commercial strategy features <strong>take-or-pay gas agreement</strong> at competitive
            pricing, supporting Nigeria's energy security while addressing historical challenges with unutilized gas capacity
            and The project incorporates <strong>Brent-linked condensate offtake arrangements</strong>. It’s
            projected to:
          </p>
          <ul className="gasmon-bullet-list">
            <li>
              <IoCheckmark className="check-icon" />
              Deliver a <strong>sub-3 year payback period</strong>
            </li>
            <li>
              <IoCheckmark className="check-icon" />
              Generate substantial <strong>revenues</strong> through market-responsive pricing mechanisms
            </li>
            <li>
              <IoCheckmark className="check-icon" />
              Achieve strong Projected <strong>IRR</strong>
            </li>
          </ul>
          The model demonstrates the economic viability of converting stranded gas resources into marketable products.
          <br />
          <br />
          <p>
            The framework builds on successful international precedents,
            prioritizing FLNG and modular gas-to-power solutions to capitalize
            on West Africa's estimated 200 TCF of stranded gas reserves. This
            approach addresses Nigeria's energy supply challenges while creating
            new revenue streams through condensate production and carbon
            credits, supporting the country's gas monetization and environmental
            compliance objectives. GGGP's alignment with Nigeria's "Decade of
            Gas" vision and recent infrastructure initiatives demonstrates its
            strategic importance in the country's energy transition.
          </p>
        </motion.div>
      </section>
    </div>
  </div>
);

export default GasMonitization;